import {ChangeDetectionStrategy, Component} from '@angular/core'
import {LinkService} from '../../../../../i18n/link.service'
import {BreakpointService} from '../../../../../../craft/utils/breakpoint.service'
import {DropdownMenu} from '../../../../../content/types/dropdown-menu.types'
import {mergeMap, Observable} from 'rxjs'
import {CallToAction} from '../../../../../content/types/call-to-action.types'
import {ApplicationRoute} from '../../../../../../craft/utils/application.route'
import {map} from 'rxjs/operators'
import {PUBLIC_ROUTES} from '../../../../../../shared/routing/public.routes'
import {TranslocoService} from '@ngneat/transloco'
import {DropdownMenuContentService} from '../../../../../content/services/dropdown-menu-content.service'

@Component({
  selector: 'bgo-craftsmen-submenu',
  templateUrl: './craftsmen-submenu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DropdownMenuContentService],
})
export class CraftsmenSubmenuComponent {
  readonly menu$: Observable<DropdownMenu> = this.contentService.getCraftsmenDropdownMenu().pipe(
    mergeMap(results => this.transloco.selectTranslate('navbar.overview').pipe(map(label => ({label, results})))),
    map(({label, results}) => {
      return {
        ...results,
        children: [
          {
            title: label,
            link: {type: 'Path', value: PUBLIC_ROUTES.PRO_DIRECTORY_PAGE, label: 'Craftsmen Overview'},
          },
          ...results.children,
        ],
      }
    }),
  )

  constructor(
    private readonly contentService: DropdownMenuContentService,
    private readonly transloco: TranslocoService,
    readonly breakpointService: BreakpointService,
    readonly linkService: LinkService,
  ) {}

  path(link: CallToAction): string | undefined {
    return link.type === 'Path' && link.value
      ? this.linkService.localizedPathTo(link.value as ApplicationRoute, undefined)
      : undefined
  }

  externalUrl(link: CallToAction): string | undefined {
    return link?.type === 'Url' ? (link.value as string) : undefined
  }
}
